import { createRouter, createWebHistory } from 'vue-router';

import AdminLayout from '../layouts/AdminLayout.vue';
import DashboardView from '../views/dashboard/DashboardView.vue';
import EnterpriseView from '../views/enterprise/EnterpriseView.vue';
import LoginView from '../views/login/LoginView.vue';
import ReportEdit from '../views/report/ReportEdit.vue';
import ReportList from '../views/report/ReportList.vue';
import ReviewList from '../views/review/ReviewList.vue';
import { clearToken, getToken, getUserCache } from '../utils/auth';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { public: true }
  },
  {
    path: '/',
    component: AdminLayout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: DashboardView,
        meta: { roles: ['enterprise', 'admin'] }
      },
      {
        path: 'reports',
        name: 'reports',
        component: ReportList,
        meta: { roles: ['enterprise'] }
      },
      {
        path: 'reports/new',
        name: 'report-create',
        component: ReportEdit,
        meta: { roles: ['enterprise'] }
      },
      {
        path: 'reports/:id',
        name: 'report-edit',
        component: ReportEdit,
        meta: { roles: ['enterprise'] }
      },
      {
        path: 'reviews',
        name: 'reviews',
        component: ReviewList,
        meta: { roles: ['admin'] }
      },
      {
        path: 'enterprise',
        name: 'enterprise',
        component: EnterpriseView,
        meta: { roles: ['enterprise', 'admin'] }
      }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  if (to.meta.public) {
    return next();
  }

  if (!getToken()) {
    return next({ name: 'login' });
  }

  const user = getUserCache();
  if (!user?.type) {
    clearToken();
    return next({ name: 'login' });
  }

  const allowedRoles = to.meta.roles;
  if (allowedRoles?.length && !allowedRoles.includes(user.type)) {
    return next({ name: 'dashboard' });
  }

  return next();
});

export default router;
